import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { ShieldCheck, Download } from 'lucide-react';
import { trackInitiateCheckout } from '../../hooks/useMetaPixel';
export function PricingCTA() {
  const handleBuyClick = () => {
    // Track the checkout initiation with Meta Pixel
    trackInitiateCheckout();
    // Redirect to Shopify cart
    window.location.href = 'https://www.mellowreset.com/cart/42955453005890:1';
  };
  return <Section id="pricing" background="gradient" className="py-20" data-id="element-88">
      <div className="max-w-3xl mx-auto bg-[#0f1419] rounded-3xl overflow-hidden shadow-[0_0_60px_rgba(212,175,55,0.15)] border border-[#d4af37]/30" data-id="element-89">
        <div className="p-8 md:p-12 text-center" data-id="element-90">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#f5f0e8] mb-2" data-id="element-91">
            Sueño Sin Dolor
          </h2>
          <p className="text-gray-400 mb-8" data-id="element-92">Guía Digital</p>

          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-93">
            <span className="text-5xl font-bold text-[#d4af37]" data-id="element-94">$6.36</span>
            <span className="text-gray-500 line-through text-xl" data-id="element-95">$18.17</span>
          </div>

          <div className="inline-block bg-[#d4af37]/20 text-[#d4af37] text-sm font-semibold px-4 py-1.5 rounded-full mb-8" data-id="element-96">
            65% de descuento
          </div>

          <div className="space-y-6 mb-10" data-id="element-97">
            <p className="text-gray-300" data-id="element-98">
              Acceso inmediato. Lo lees en 20 minutos y{' '}
              <strong className="text-[#f5f0e8]" data-id="element-99">
                esa misma noche lo aplicas.
              </strong>
            </p>

            <Button size="lg" fullWidth className="text-lg h-16" onClick={handleBuyClick} data-id="element-100">
              Quiero dormir mejor
            </Button>

            <div className="flex justify-center gap-6 text-xs text-gray-500" data-id="element-101">
              <span className="flex items-center gap-1" data-id="element-102">
                <ShieldCheck size={14} data-id="element-103" /> Pago Seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-104">
                <Download size={14} data-id="element-105" /> Descarga Instantánea
              </span>
            </div>
          </div>
        </div>

        <div className="bg-[#1a1f2e] p-4 text-center border-t border-[#2a3245]" data-id="element-106">
          <p className="text-sm text-gray-400" data-id="element-107">
            Oferta especial de lanzamiento. Precio sujeto a cambio.
          </p>
        </div>
      </div>
    </Section>;
}